import { ColumnPinningState } from "@tanstack/react-table";
import { createContext } from "react";

interface DataTableColumnPinning {
  columnPinning: ColumnPinningState;
}

const DataTableColumnPinningContext =
  createContext<DataTableColumnPinning | null>(null);

export default DataTableColumnPinningContext;
